import DriverContractListingByRailyListingItem from "../types/driver-contract-listing-by-raily-listing-item";
import DriverContractListingByRailySortKey from "../types/driver-contract-listing-by-raily-sort-key";

const sortListingItemsByBillingModelAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemA.billingModel.localeCompare(itemB.billingModel)
  );
};

const sortListingItemsByBillingModelDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemB.billingModel.localeCompare(itemA.billingModel)
  );
};

const sortListingItemsByDistanceRateAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) => itemA.distanceRate - itemB.distanceRate
  );
};

const sortListingItemsByDistanceRateDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) => itemB.distanceRate - itemA.distanceRate
  );
};

const sortListingItemsByHaltingTimeGracePeriodAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemA.freeStoppingPeriodMinutes - itemB.freeStoppingPeriodMinutes
  );
};

const sortListingItemsByHaltingTimeGracePeriodDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemB.freeStoppingPeriodMinutes - itemA.freeStoppingPeriodMinutes
  );
};

const sortListingItemsByHaltingTimeRateAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) => itemA.stoppingRate - itemB.stoppingRate
  );
};

const sortListingItemsByHaltingTimeRateDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) => itemB.stoppingRate - itemA.stoppingRate
  );
};

const sortListingItemsByPeriodOfValidityFromAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemB.periodOfValidity.from.getTime() -
      itemA.periodOfValidity.from.getTime()
  );
};

const sortListingItemsByPeriodOfValidityFromDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemA.periodOfValidity.from.getTime() -
      itemB.periodOfValidity.from.getTime()
  );
};

const sortListingItemsByPeriodOfValidityToAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemB.periodOfValidity.to.getTime() - itemA.periodOfValidity.to.getTime()
  );
};

const sortListingItemsByPeriodOfValidityToDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort(
    (itemA, itemB) =>
      itemA.periodOfValidity.to.getTime() - itemB.periodOfValidity.to.getTime()
  );
};

const sortListingItemsByTaxiCorporationAsc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemA.taxiCorporation.localeCompare(itemB.billingModel)
  );
};

const sortListingItemsByTaxiCorporationDesc = (
  listingItems: DriverContractListingByRailyListingItem[]
): DriverContractListingByRailyListingItem[] => {
  return listingItems.sort((itemA, itemB) =>
    itemB.taxiCorporation.localeCompare(itemA.billingModel)
  );
};

const sortListingItems = (
  listingItems: DriverContractListingByRailyListingItem[],
  sortKey: DriverContractListingByRailySortKey | null
): DriverContractListingByRailyListingItem[] => {
  switch (sortKey) {
    case DriverContractListingByRailySortKey.BILLING_MODEL_ASC:
      return sortListingItemsByBillingModelAsc(listingItems);
    case DriverContractListingByRailySortKey.BILLING_MODEL_DESC:
      return sortListingItemsByBillingModelDesc(listingItems);
    case DriverContractListingByRailySortKey.DISTANCE_RATE_ASC:
      return sortListingItemsByDistanceRateAsc(listingItems);
    case DriverContractListingByRailySortKey.DISTANCE_RATE_DESC:
      return sortListingItemsByDistanceRateDesc(listingItems);
    case DriverContractListingByRailySortKey.FREE_STOPPING_PERIOD_ASC:
      return sortListingItemsByHaltingTimeGracePeriodAsc(listingItems);
    case DriverContractListingByRailySortKey.FREE_STOPPING_PERIOD_DESC:
      return sortListingItemsByHaltingTimeGracePeriodDesc(listingItems);
    case DriverContractListingByRailySortKey.STOPPING_RATE_ASC:
      return sortListingItemsByHaltingTimeRateAsc(listingItems);
    case DriverContractListingByRailySortKey.STOPPING_RATE_DESC:
      return sortListingItemsByHaltingTimeRateDesc(listingItems);
    case DriverContractListingByRailySortKey.PERIOD_OF_VALIDITY_FROM_ASC:
      return sortListingItemsByPeriodOfValidityFromAsc(listingItems);
    case DriverContractListingByRailySortKey.PERIOD_OF_VALIDITY_FROM_DESC:
      return sortListingItemsByPeriodOfValidityFromDesc(listingItems);
    case DriverContractListingByRailySortKey.PERIOD_OF_VALIDITY_TO_ASC:
      return sortListingItemsByPeriodOfValidityToAsc(listingItems);
    case DriverContractListingByRailySortKey.PERIOD_OF_VALIDITY_TO_DESC:
      return sortListingItemsByPeriodOfValidityToDesc(listingItems);
    case DriverContractListingByRailySortKey.TAXI_CORPORATION_ASC:
      return sortListingItemsByTaxiCorporationAsc(listingItems);
    case DriverContractListingByRailySortKey.TAXI_CORPORATION_DESC:
      return sortListingItemsByTaxiCorporationDesc(listingItems);
    default:
      return listingItems;
  }
};

const driverContractListingByRailySortService = {
  sortListingItems,
};

export default driverContractListingByRailySortService;
